import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import Actions from "./actions";
import { bonusRewardsResponse } from '../rewards/mockResponses';
import { apiUtil } from '../../util';
import * as UTIL from '../../util';
import { errorDuck } from '../error';
import moment from 'moment';
import { LoyaltyAccountStatus } from '../../util/LoyaltyAccountStatus';
import { getSessionStorageKey } from '../../util/sessionStorage';
var Creators = Actions.Creators;
var loyaltyAccountData = Creators.accountData;
var resetAccountData = Creators.resetAccountData;
var setPersonalizationModals = Creators.setPersonalizationModals;
var setTransactionLimitInfo = Creators.setTransactionLimitInfo;
var setErrorMessage = Creators.setErrorMessage;
var errorOperations = errorDuck.operations;
var receiveError = errorOperations.receiveError;

var setLoyaltyAccountData = function setLoyaltyAccountData(account) {
  window.dispatchEvent(new CustomEvent("customEventSetLoyaltyAccountData", {
    detail: {
      account: account
    }
  }));
  return function (dispatch) {
    dispatch(loyaltyAccountData(account));
  };
};

function checkBirthdayReward(state) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var _state$account, _state$account$aadRes, _state$account$aadRes2, _state$account$aadRes3, _state$account2, _state$account2$aadRe, _state$account2$aadRe2, _state$account2$aadRe3, _state$account3, _state$account3$aadRe;

      var email, token, _res$loyalty, _res$loyalty$customer, _res$loyalty$customer2, res, flag, url;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              email = ((_state$account = state.account) === null || _state$account === void 0 ? void 0 : (_state$account$aadRes = _state$account.aadResponse) === null || _state$account$aadRes === void 0 ? void 0 : (_state$account$aadRes2 = _state$account$aadRes.account) === null || _state$account$aadRes2 === void 0 ? void 0 : (_state$account$aadRes3 = _state$account$aadRes2.idToken) === null || _state$account$aadRes3 === void 0 ? void 0 : _state$account$aadRes3.email) || ((_state$account2 = state.account) === null || _state$account2 === void 0 ? void 0 : (_state$account2$aadRe = _state$account2.aadResponse) === null || _state$account2$aadRe === void 0 ? void 0 : (_state$account2$aadRe2 = _state$account2$aadRe.account) === null || _state$account2$aadRe2 === void 0 ? void 0 : (_state$account2$aadRe3 = _state$account2$aadRe2.idToken) === null || _state$account2$aadRe3 === void 0 ? void 0 : _state$account2$aadRe3.signInName);
              token = (_state$account3 = state.account) === null || _state$account3 === void 0 ? void 0 : (_state$account3$aadRe = _state$account3.aadResponse) === null || _state$account3$aadRe === void 0 ? void 0 : _state$account3$aadRe.jwtIdToken; // storybook mock

              if (!(window.location.href.indexOf('localhost:9009') > -1)) {
                _context.next = 7;
                break;
              }

              res = bonusRewardsResponse;
              flag = false;
              (_res$loyalty = res.loyalty) === null || _res$loyalty === void 0 ? void 0 : (_res$loyalty$customer = _res$loyalty.customers) === null || _res$loyalty$customer === void 0 ? void 0 : (_res$loyalty$customer2 = _res$loyalty$customer.customerCoupons) === null || _res$loyalty$customer2 === void 0 ? void 0 : _res$loyalty$customer2.forEach(function (coupon) {
                var _ref2 = coupon !== null && coupon !== void 0 ? coupon : {},
                    reward = _ref2.reward;

                if (reward && coupon.status === 'redeemed' && (reward === null || reward === void 0 ? void 0 : reward.rewardType) === 'birthday') {
                  flag = true;
                }
              });
              return _context.abrupt("return", Promise.resolve(flag || false));

            case 7:
              if (email) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", Promise.resolve(false));

            case 9:
              url = apiUtil.API.loyalty.getBonusRewards.replace('{email}', email);
              return _context.abrupt("return", UTIL.apiUtil.fetchGet(url, token).then(function (res) {
                if (res) {
                  var _res$loyalty2, _res$loyalty2$custome, _res$loyalty2$custome2;

                  var _flag = false;
                  (_res$loyalty2 = res.loyalty) === null || _res$loyalty2 === void 0 ? void 0 : (_res$loyalty2$custome = _res$loyalty2.customers) === null || _res$loyalty2$custome === void 0 ? void 0 : (_res$loyalty2$custome2 = _res$loyalty2$custome.customerCoupons) === null || _res$loyalty2$custome2 === void 0 ? void 0 : _res$loyalty2$custome2.forEach(function (coupon) {
                    var _ref3 = coupon !== null && coupon !== void 0 ? coupon : {},
                        reward = _ref3.reward;

                    if (reward && coupon.status === 'redeemed' && (reward === null || reward === void 0 ? void 0 : reward.rewardType) === 'birthday') {
                      _flag = true;
                    }
                  });
                  return _flag || false;
                } else {
                  return false;
                }
              }).catch(function (err) {
                console.error('Error on Rewards request: ', err);
                dispatch(receiveError(UTIL.buildError(err)));
              }));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function checkPersonalizationOverlays(state) {
  var disabledOverlays = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var _loyalty$account6;

      var loyalty, checkPegLevelReached, checkAnniversary, isBirthday, isPegLevelReached, isAnniversary;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              loyalty = state.loyalty;

              checkPegLevelReached = function checkPegLevelReached() {
                var _loyalty$account;

                if (((_loyalty$account = loyalty.account) === null || _loyalty$account === void 0 ? void 0 : _loyalty$account.Balance) && parseInt(loyalty.account.Balance) > 0) {
                  var _loyalty$account2;

                  if (((_loyalty$account2 = loyalty.account) === null || _loyalty$account2 === void 0 ? void 0 : _loyalty$account2.Balance) >= 75) {
                    return true;
                  }
                }

                return false;
              };

              checkAnniversary = function checkAnniversary() {
                var _loyalty$account3;

                if ((_loyalty$account3 = loyalty.account) === null || _loyalty$account3 === void 0 ? void 0 : _loyalty$account3.EnrolledAt) {
                  var _loyalty$account4, _loyalty$account5;

                  var month = moment((_loyalty$account4 = loyalty.account) === null || _loyalty$account4 === void 0 ? void 0 : _loyalty$account4.EnrolledAt).format('MM');
                  var year = moment((_loyalty$account5 = loyalty.account) === null || _loyalty$account5 === void 0 ? void 0 : _loyalty$account5.EnrolledAt).format('YYYY');
                  var currentMonth = moment().format('MM');
                  var currentYear = moment().format('YYYY');
                  return month === currentMonth && year < currentYear;
                }

                return false;
              };

              if (!((loyalty === null || loyalty === void 0 ? void 0 : (_loyalty$account6 = loyalty.account) === null || _loyalty$account6 === void 0 ? void 0 : _loyalty$account6.Status) !== LoyaltyAccountStatus.Paused)) {
                _context2.next = 10;
                break;
              }

              _context2.next = 6;
              return dispatch(checkBirthdayReward(state));

            case 6:
              isBirthday = _context2.sent;
              isPegLevelReached = checkPegLevelReached();
              isAnniversary = checkAnniversary();

              if (isBirthday && !disabledOverlays.includes('birthday')) {
                dispatch(setPersonalizationModals('birthday'));
              } else if (isPegLevelReached && !disabledOverlays.includes('pegLevelReached')) {
                dispatch(setPersonalizationModals('pegLevelReached'));
              } else if (isAnniversary && !disabledOverlays.includes('anniversary')) {
                dispatch(setPersonalizationModals('anniversary'));
              }

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
}

var handleCheckPersonalizationOverlays = function handleCheckPersonalizationOverlays() {
  var disabledOverlays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", dispatch(checkPersonalizationOverlays(getState(), disabledOverlays)));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }();
};

function getAccountInformation(state) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      var _state$account4, _state$account4$aadRe, _state$account4$aadRe2, _state$account4$aadRe3, _state$account5, _state$account5$aadRe, _state$account5$aadRe2, _state$account5$aadRe3, _state$account6, _state$account6$aadRe;

      var email, token, url;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              email = ((_state$account4 = state.account) === null || _state$account4 === void 0 ? void 0 : (_state$account4$aadRe = _state$account4.aadResponse) === null || _state$account4$aadRe === void 0 ? void 0 : (_state$account4$aadRe2 = _state$account4$aadRe.account) === null || _state$account4$aadRe2 === void 0 ? void 0 : (_state$account4$aadRe3 = _state$account4$aadRe2.idToken) === null || _state$account4$aadRe3 === void 0 ? void 0 : _state$account4$aadRe3.email) || ((_state$account5 = state.account) === null || _state$account5 === void 0 ? void 0 : (_state$account5$aadRe = _state$account5.aadResponse) === null || _state$account5$aadRe === void 0 ? void 0 : (_state$account5$aadRe2 = _state$account5$aadRe.account) === null || _state$account5$aadRe2 === void 0 ? void 0 : (_state$account5$aadRe3 = _state$account5$aadRe2.idToken) === null || _state$account5$aadRe3 === void 0 ? void 0 : _state$account5$aadRe3.signInName);
              token = (_state$account6 = state.account) === null || _state$account6 === void 0 ? void 0 : (_state$account6$aadRe = _state$account6.aadResponse) === null || _state$account6$aadRe === void 0 ? void 0 : _state$account6$aadRe.jwtIdToken;

              if (!(!email || !token)) {
                _context4.next = 4;
                break;
              }

              return _context4.abrupt("return", Promise.resolve(false));

            case 4:
              url = apiUtil.API.loyalty.getAccountDetails.replace('{email}', email);
              return _context4.abrupt("return", apiUtil.fetchGet(url, token).then(function (response) {
                var _response$loyalty;

                var customers = (response === null || response === void 0 ? void 0 : (_response$loyalty = response.loyalty) === null || _response$loyalty === void 0 ? void 0 : _response$loyalty.customers) || {};

                if (customers === null || customers === void 0 ? void 0 : customers.email) {
                  var _customers$eventSumma;

                  var newResponse = {
                    FirstName: (customers === null || customers === void 0 ? void 0 : customers.firstName) || "",
                    LastName: (customers === null || customers === void 0 ? void 0 : customers.lastName) || "",
                    HomePhone: (customers === null || customers === void 0 ? void 0 : customers.mobilePhone) || (customers === null || customers === void 0 ? void 0 : customers.homePhone) || "",
                    ExternalCustomerId: (customers === null || customers === void 0 ? void 0 : customers.externalCustomerId) || "",
                    Balance: (customers === null || customers === void 0 ? void 0 : customers.balance) || 0,
                    EnrolledAt: (customers === null || customers === void 0 ? void 0 : customers.enrolledAt) || "",
                    Email: (customers === null || customers === void 0 ? void 0 : customers.email) || "",
                    Birthdate: (customers === null || customers === void 0 ? void 0 : customers.birthdate) || "",
                    Unsubscribed: (customers === null || customers === void 0 ? void 0 : customers.unsubscribed) ? true : false,
                    Status: (customers === null || customers === void 0 ? void 0 : customers.status) || "",
                    customerCoupons: (customers === null || customers === void 0 ? void 0 : customers.customerCoupons) || [],
                    customerRewards: (customers === null || customers === void 0 ? void 0 : customers.customerRewards) || []
                  };
                  dispatch(loyaltyAccountData(newResponse));
                  dispatch(setTransactionLimitInfo({
                    transactionLimitReached: (customers === null || customers === void 0 ? void 0 : (_customers$eventSumma = customers.eventSummary) === null || _customers$eventSumma === void 0 ? void 0 : _customers$eventSumma.transactionsAllowedToEarn) > 0 ? false : true
                  }));
                }
              }).catch(function (err) {
                console.error('Error getting account information: ', err);
                dispatch(receiveError(UTIL.buildError(err)));
              }));

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x5) {
      return _ref6.apply(this, arguments);
    };
  }();
}

var handleGetAccountInformation = function handleGetAccountInformation() {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", dispatch(getAccountInformation(getState())));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x6, _x7) {
      return _ref7.apply(this, arguments);
    };
  }();
};

function checkTransactionLimit(state) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch) {
      var _loyalty$transactionL;

      var loyalty;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              loyalty = state.loyalty;

              if (loyalty === null || loyalty === void 0 ? void 0 : (_loyalty$transactionL = loyalty.transactionLimitInfo) === null || _loyalty$transactionL === void 0 ? void 0 : _loyalty$transactionL.transactionLimitReached) {
                dispatch(setTransactionLimitInfo({
                  showTransactionLimitModal: true
                }));
              }

            case 2:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x8) {
      return _ref8.apply(this, arguments);
    };
  }();
}

var handleCheckTransactionLimit = function handleCheckTransactionLimit() {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", dispatch(checkTransactionLimit(getState())));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x9, _x10) {
      return _ref9.apply(this, arguments);
    };
  }();
};

export default {
  setLoyaltyAccountData: setLoyaltyAccountData,
  setPersonalizationModals: setPersonalizationModals,
  handleCheckPersonalizationOverlays: handleCheckPersonalizationOverlays,
  handleGetAccountInformation: handleGetAccountInformation,
  resetAccountData: resetAccountData,
  setTransactionLimitInfo: setTransactionLimitInfo,
  handleCheckTransactionLimit: handleCheckTransactionLimit,
  setErrorMessage: setErrorMessage
};